/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HomeHealthCertificationReviewReason = {
    AmbiguousDocument: 'ambiguous_document',
    AttestationNotFound: 'attestation_not_found',
    DateMismatch: 'date_mismatch',
    FollowingPractitionerNotFound: 'following_practitioner_not_found',
    IndirectEvidence: 'indirect_evidence',
    MissingSignature: 'missing_signature',
    NotHomeHealthSpecific: 'not_home_health_specific',
    RecommendationOnly: 'recommendation_only',
    SupportingDocumentNotFound: 'supporting_document_not_found',
    Other: 'other'
} as const;
export type HomeHealthCertificationReviewReason = typeof HomeHealthCertificationReviewReason[keyof typeof HomeHealthCertificationReviewReason];


export function instanceOfHomeHealthCertificationReviewReason(value: any): boolean {
    for (const key in HomeHealthCertificationReviewReason) {
        if (Object.prototype.hasOwnProperty.call(HomeHealthCertificationReviewReason, key)) {
            if (HomeHealthCertificationReviewReason[key as keyof typeof HomeHealthCertificationReviewReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HomeHealthCertificationReviewReasonFromJSON(json: any): HomeHealthCertificationReviewReason {
    return HomeHealthCertificationReviewReasonFromJSONTyped(json, false);
}

export function HomeHealthCertificationReviewReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationReviewReason {
    return json as HomeHealthCertificationReviewReason;
}

export function HomeHealthCertificationReviewReasonToJSON(value?: HomeHealthCertificationReviewReason | null): any {
    return value as any;
}

export function HomeHealthCertificationReviewReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): HomeHealthCertificationReviewReason {
    return value as HomeHealthCertificationReviewReason;
}

